<template>
  <v-form>
    <v-container>
      <v-layout row wrap>
        <v-flex xs12>
          <v-text-field
            label="入荷データファイル"
            @click="pickFile"
            v-model="fileName"
            prepend-icon="attach_file"
            hint="CSVファイル"
            v-validate="'required'"
            data-vv-name="userId"
            :error-messages="errors.collect('storeCode')"
          ></v-text-field>
          <input
            type="file"
            ref="file"
            style="display: none"
            accept=".csv, .xls"
            @change="onFileChange($event)"
          />
        </v-flex>
      </v-layout>      
      <div style="height: 20px;"></div>

      <v-layout row wrap>
        <v-flex xs12 sm3>
          <v-btn block color="#4C728A" dark :to="{ name: 'admin/new-admin-menu' }">
            <v-icon color="black" left>home</v-icon>{{ $t('home-btn') }}
          </v-btn>
        </v-flex>        
        <v-flex xs12 sm3>
          <v-btn block color="success" dark :loading="loading1" @click="fileUpload()">
            <v-icon dark left>cloud_upload</v-icon>アップロード実行
          </v-btn>
        </v-flex>        
      </v-layout>
      <br />
    </v-container>
  </v-form>
</template>

<script>
import ServerApiCallService from '@/services/ServerApiCallService.js'
import axios from 'axios'

export default {
  created() {
    console.log('created')
    ServerApiCallService.setAppJs(this.$parent.$parent.$parent)
  },
  methods: {
    pickFile() {
      this.$refs.file.click()
    },
    onFileChange(e) {
      // const files = e.target.files
      this.targetFile = e.target.files[0]

      if (this.targetFile !== undefined) {
        this.fileName = this.targetFile.name
      }
    },
    fileUpload() {
      let thisObj = this
      // FormData を利用して File を POST する
      let formData = new FormData()
      formData.append('uploadFile', this.targetFile)
      formData.append('charsetName', this.fileFormat)

      let sendContext = {
        hasDialogComponent: this.$parent.$parent.$parent
      }

      this.$validator.validateAll().then(result => {
        if (!result) {
          this.$parent.$parent.$parent.showErrorDialog(this.$t('hasInputError'))
          return
        }
      })

      thisObj.loading1 = true
      ServerApiCallService.sendWarehouseReceivingFile(formData, sendContext)
        .then(response => {
          // 버튼의 빙글빙글 돌게 하는거
          thisObj.loading1 = false

          if (response.data.errors.length > 0) {
            alert(response.data.errors[0].errorDescription)
          } else {
            alert("Successfully registered")
          }
        })
        .catch(error => {
          thisObj.loading1 = false
        })
    }
  },
  data() {
    return {
      loading1: false,
      fileName: '',
      fileFormat: 'SHIFT-JIS'
    }
  }
}
</script>

<style>
.column-input {
  width: 100% !important;
  height: 30px;
  text-align: right;
  border: 1px solid #c7c7c7;
  padding: 0 4px;
}
</style>
